import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const WaveIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <circle cx="8" cy="8" r="8" fill={props.fill} />
      <path
        d="M1 3C1.83333 1.49075 3.9 -0.622193 5.5 3C7.1 6.62219 9.16667 4.50925 10 3"
        transform="translate(3,5)"
        stroke="black"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
});
